<template>
    <ConfirmationForm
        :type="AssortmentType.LatestServer"
        :price="monthlyPrice"
        :setup-price="setupPrice"
        :configuration="mailSummary"
        :selection="selection"
        :redirect-params="`?redirect=dedicated-server/confirm&query=${queryParams}`"
    />
</template>

<script setup>
import { useAssortmentDedicated } from '../composables/assortmentDedicated';
import ConfirmationForm from './ConfirmationForm.vue';
import { getQueryParams } from '../../../utils/windowUtils';
import { AssortmentType } from '../../../types';
import { onMounted } from 'vue';
import { pushToGoogleTagManager } from '../../../utils/googleTagManagerUtils';

const props = defineProps({
    assortmentContent: { type: String, default: '' },
    assortmentNetworkContent: { type: String, default: '' },
    assortmentIpContent: { type: String, default: '' },
});

const queryParams = getQueryParams('|');
const { monthlyPrice, setupPrice, mailSummary, selection } = useAssortmentDedicated(
    props.assortmentContent,
    props.assortmentNetworkContent,
    props.assortmentIpContent
);

onMounted(() => {
    pushToGoogleTagManager({
        event: `${AssortmentType.LatestServer.toLowerCase()}-config-page-2-continue`,
        conversionValue: monthlyPrice.value,
    });
});
</script>
